import React from 'react';

interface InputAreaProps {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  disabled?: boolean;
}

const InputArea: React.FC<InputAreaProps> = ({ value, onChange, onSend, disabled }) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <div className="input-area" style={{ padding: '1rem', borderTop: '1px solid #2e2e2e', display: 'flex', gap: '0.5rem', background: '#121212' }}>
      <input
        type="text"
        placeholder="Type a message..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        style={{ flex: 1, padding: '0.75rem', border: '1px solid #2e2e2e', borderRadius: '8px', background: '#1a1a1e', color: '#ffffff', outline: 'none' }}
      />
      <button
        onClick={onSend}
        disabled={disabled || !value.trim()}
        style={{ background: '#8b5cf6', color: 'white', border: 'none', padding: '0 1.5rem', borderRadius: '8px', cursor: 'pointer', fontWeight: 600, opacity: disabled ? 0.5 : 1, transition: 'background 0.2s' }}
      >
        Send
      </button>
    </div>
  );
};

export default InputArea;
